import './breadcrumb.scss'
import { Link } from 'react-router-dom'

const BreadCrumbs = ({ breadCrumbsArr }) => {
  return (
    <div className='flex flex-column sm-breadCrumbs'>
      {breadCrumbsArr?.length > 0 && <span className='first-breadcrumb'>{breadCrumbsArr[0].title}</span>}
      <div className='flex'>
        {breadCrumbsArr?.slice(1).map((eachBreadCrumb, index) => (
          <div className='flex' key={index + 1}>
            <Link to={eachBreadCrumb.link} className='link-to flex'>
              <span className='link-breadcrumb'>{eachBreadCrumb.title}</span>
            </Link>
            {index < breadCrumbsArr.length - 2 && <span className='breadcrumb-slash'>/</span>}
          </div>
        ))}
      </div>
    </div>
  )
}

export default BreadCrumbs
